import validFileNumber from '../libraries/valid-file-number'
import validFileSize from '../libraries/valid-file-size'
import AmountFormatter from '../libraries/amount-formatter'
import Vue from 'vue'
import bankAccountIndexVue from '../components/stores/bank-account.vue'

export default {

  common() {
    const script = document.createElement('script')
    script.src = "https://ajaxzip3.github.io/ajaxzip3.js"
    document.head.appendChild(script)

    document.addEventListener('DOMContentLoaded', () => {

      if(document.getElementById('current_wizard_index') != null) {
        if(document.getElementById('current_wizard_index').value == 5) {
          new Vue({
            el: '#input_bank_account',
            render: h => h(bankAccountIndexVue)
          })
        }
      }

      Array.from(document.getElementsByClassName('btn-back')).forEach(element => {
        element.addEventListener('click', () => {
          const form = document.getElementById('wizard-form')
          form.action = '/stores/wizard/back'
          form.submit()
        })
      })

      Array.from(document.getElementsByClassName('btn-wizard-back')).forEach(element => {
        element.addEventListener('click', (event) => {
          const form = document.getElementById('wizard-form')
          const currentWizardIndexField = document.getElementById('current-wizard-index')
          currentWizardIndexField.value = event.srcElement.dataset.currentWizardIndex
          form.action = '/stores/wizard/back'
          form.submit()
        })
      })

      Array.from(document.getElementsByTagName('input')).forEach(element => {
        if (element.type != 'text') return
        element.addEventListener('keypress', () => {
          if (event.keyCode == 13) {
            event.preventDefault()
          }
        })
      })

      Array.from(document.getElementsByClassName('zip-search-btn')).forEach(element => {
        element.addEventListener('click', () => {
          const zip_code = element.previousElementSibling
          const state = document.getElementsByName(zip_code.name.replace('[zip_code]', '[state]'))[0]
          const city = document.getElementsByName(zip_code.name.replace('[zip_code]', '[city]'))[0]
          const street = document.getElementsByName(zip_code.name.replace('[zip_code]', '[street]'))[0]
          AjaxZip3.zip2addr(zip_code, '', state.name, city.name, street.name)
        })
      })

      const uploadObjects = [
        {elementName: 'business_scheme_file', limitSizeMB: 10},
        {elementName: 'representative_auth_file', limitSizeMB: 10},
        {elementName: 'representative_other_file', limitSizeMB: 10}
      ]

      uploadObjects.forEach(uploadObject => {
        Array.from(document.getElementsByClassName(uploadObject.elementName)).forEach(el => {
          el.addEventListener('change', (e) => {
            validFileSize(uploadObject.limitSizeMB, e)
          })
        })
      })

      Array.from(document.getElementsByClassName('upload_delete')).forEach(el => {
        el.addEventListener('click', (e) => {
          // DOM構造に依存した処理はアンチパターンだが時間がないのでこの形で‥。
          el.parentNode.parentElement.getElementsByTagName('input')[0].value = true
          el.parentElement.parentElement.getElementsByTagName('img')[0].style.display = 'none'
          el.parentElement.parentElement.getElementsByClassName('actions')[0].style.display = 'none'
          el.parentElement.parentElement.previousElementSibling.style.display = 'block'
        })
      })

      Array.from(document.getElementsByClassName('image-control')).forEach(el => {
        const img = el.getElementsByTagName('img')[0]
        if (!img) return
        // DOM構造に依存した処理はアンチパターンだが時間がないのでこの形で‥。
        el.previousElementSibling.style.display = 'none'
      })

      function payment_method_other_text_enable(el) {
        const other_text = document.getElementById('examination_payment_method_other_text')
        if (el.value === "" || parseInt(el.value) !== 4) {
          other_text.value = null
          other_text.readOnly = true
        } else {
          other_text.readOnly = false
        }
      }

      Array.from(document.getElementsByName('examination[payment_method]')).forEach(el => {
        payment_method_other_text_enable(el)
        el.addEventListener('change', (e) => {
          payment_method_other_text_enable(el)
        })
      })

      function card_information_retention_status(element) {
        const date = document.getElementById('examination_scheduled_non_retention_date_1i');
        const month = document.getElementById('examination_scheduled_non_retention_date_2i');
        const day = document.getElementById('examination_scheduled_non_retention_date_3i');

        if (element.value === '3') {
          date.disabled = false;
          month.disabled = false;
          day.disabled = false;
        } else {
          date.disabled = true;
          month.disabled = true;
          day.disabled = true;
        }
      }

      Array.from(document.getElementsByName('examination[card_information_retention_status]')).forEach(element => {
        window.addEventListener('load', (e) => {
          card_information_retention_status(element)
        })

        element.addEventListener('change', (e) => {
          card_information_retention_status(element)
        })
      })

      function pcidss_compliance_status(element) {
        const date = document.getElementById('examination_pcidss_compliant_date_1i');
        const month = document.getElementById('examination_pcidss_compliant_date_2i');
        const day = document.getElementById('examination_pcidss_compliant_date_3i');

        if (element.value === '2') {
          date.disabled = false;
          month.disabled = false;
          day.disabled = false;
        } else {
          date.disabled = true;
          month.disabled = true;
          day.disabled = true;
        }
      }

      Array.from(document.getElementsByName('examination[pcidss_compliance_status]')).forEach(element => {
        window.addEventListener('load', (e) => {
          pcidss_compliance_status(element)
        })

        element.addEventListener('change', (e) => {
          pcidss_compliance_status(element)
        })
      })

      // 金額にカンマを付けるライブラリをインポート
      new AmountFormatter().Run();

      Array.from(document.getElementsByClassName('corporation_self_business')).forEach(el => {
        Array.from(document.getElementsByClassName('corporation_area')).forEach(area => {
          area.style.display = el.checked == false ? "" : "none"
        })
        el.addEventListener('change', (e) => {
          Array.from(document.getElementsByClassName('corporation_area')).forEach(area => {
            area.style.display = el.checked == false ? "" : "none"
          })
        })
      })

      // 同一住所の入力補完
      const completion_addr = document.getElementById('completion_addr');
      if(completion_addr != null) {
        const corporation_flg = document.getElementById('_storage_corporation_corporation_flg');
        const common_store_zip_code  = document.getElementById('common_store_zip_code');
        const common_store_state = document.getElementById('common_store_state');
        const common_store_city = document.getElementById('common_store_city');
        const common_store_street = document.getElementById('common_store_street');
        const common_store_building = document.getElementById('common_store_building');
        const common_store_city_kana = document.getElementById('common_store_city_kana');
        const common_store_street_kana = document.getElementById('common_store_street_kana');
        const common_store_building_kana = document.getElementById('common_store_building_kana');
        const common_store_city_en = document.getElementById('common_store_city_en');
        const common_store_street_en = document.getElementById('common_store_street_en');
        const common_store_building_en = document.getElementById('common_store_building_en');
        if(corporation_flg === null || common_store_zip_code === null || common_store_state === null || common_store_city === null || common_store_street === null || common_store_building === null || common_store_city_kana === null || common_store_street_kana === null || common_store_building_kana === null) {
          return;
        }
        let zip_code, state, city, street, building, city_kana, street_kana, building_kana;

        const prefix = corporation_flg.value === '0' ? '_storage_representative_' : '_storage_corporation_'
        zip_code = document.getElementById(prefix + 'zip_code');
        state = document.getElementById(prefix + 'state');
        city = document.getElementById(prefix + 'city');
        street = document.getElementById(prefix + 'street');
        building = document.getElementById(prefix + 'building');
        city_kana = document.getElementById(prefix + 'city_kana');
        street_kana = document.getElementById(prefix + 'street_kana');
        building_kana = document.getElementById(prefix + 'building_kana');

        if(zip_code === null || state === null || city === null || street === null || building === null || city_kana === null || street_kana === null || building_kana === null) {
          return;
        }

        let city_en, street_en, building_en;
        if(corporation_flg.value === '0') {
          city_en = document.getElementById(prefix + 'city_en');
          street_en = document.getElementById(prefix + 'street_en');
          building_en = document.getElementById(prefix + 'building_en');
        }

        completion_addr.addEventListener('click', () => {
          common_store_zip_code.value = zip_code.value;
          common_store_state.value = state.value;
          common_store_city.value = city.value;
          common_store_street.value = street.value;
          common_store_building.value = building.value;
          common_store_city_kana.value = city_kana.value;
          common_store_street_kana.value = street_kana.value;
          common_store_building_kana.value = building_kana.value;
          if(city_en !== null) common_store_city_en.value = city_en.value;
          if(street_en !== null) common_store_street_en.value = street_en.value;
          if(building_en !== null) common_store_building_en.value = building_en.value;
        }, false);
      }

      Array.from([document.getElementById('copy-corporate-search-results')]).forEach(element => {
        if(element === null) return
        element.addEventListener('click', () => {
          let token = ''
          Array.from(document.getElementsByTagName('meta')).forEach(meta => {
            if (meta.name != 'csrf-token') return
            token = meta.content
          })

          const corporation_number = document.getElementById('corporation_number')
          if(corporation_number.value.length !== 13) {
            return
          }

          const xhr = new XMLHttpRequest()
          xhr.open('GET', '/api/v1/corporates/' + corporation_number.value)
          xhr.setRequestHeader( 'X-CSRF-Token', token)
          xhr.setRequestHeader('Content-Type', 'application/json')
          xhr.send()
          xhr.addEventListener('load', function(result) {
            if (result.currentTarget.status == 200) {
              if (result.currentTarget.responseText.length == 0) {
                return
              }
              const json = JSON.parse(result.currentTarget.responseText)

              document.getElementById('corporation_name').value = json['name']
              document.getElementById('corporation_name_kana').value = json['furigana']
              document.getElementById('corporation_zip_code').value = json['post_code']
              document.getElementById('corporation_state').value = json['prefecture_name']
              document.getElementById('corporation_city').value = json['city_name']
              document.getElementById('corporation_street').value = json['street_number']
            } else {
              alert('法人情報が取得できませんでした')
            }
          })
        })
      })
    })
  },

  // startWizard() {
  //   window.addEventListener('load', () => {

  //   document.getElementById('terms').style.height =
  //     window.outerHeight - document.getElementById('app-header').clientHeight - document.getElementById('app-footer').clientHeight - 100 + 'px'

  //   })
  // }

}
